module.exports = __webpack_public_path__ + "img/arrow-left.a70e7f9e.svg";